export default "__VITE_ASSET__Cg_ASA$C__"